import { Box, Chip, TextField, makeStyles } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  autocompleteInput: {
    "& .MuiOutlinedInput-root": {
      height: 30,
      minHeight: 30,
      maxHeight: 30,
      borderRadius: 8,
      fontSize: "0.80rem",
      backgroundColor: theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.03)" : "#FFFFFF",
      boxSizing: "border-box",
      padding: "2px 8px !important",
      display: "flex",
      alignItems: "center",
      transition: "border-color 0.2s, box-shadow 0.2s",
      "&:hover": {
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-focused": {
        boxShadow: `0 0 8px ${theme.palette.primary.main}40`,
      },
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      padding: "2px 8px !important",
      height: 30,
      minHeight: 30,
      maxHeight: 30,
      display: "flex",
      alignItems: "center",
      flexWrap: "nowrap",
      overflow: "hidden",
      boxSizing: "border-box",
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input': {
      padding: "2px 4px !important",
      fontSize: "0.80rem",
      minWidth: 40,
    },
    "& .MuiOutlinedInput-input": {
      padding: "4px 8px !important",
      fontSize: "0.80rem",
    },
    "& .MuiAutocomplete-popupIndicator": {
      padding: "4px !important",
    },
    "& .MuiAutocomplete-clearIndicator": {
      padding: "4px !important",
    },
    "& .MuiInputLabel-outlined": {
      fontSize: "0.80rem",
      transform: "translate(14px, 7px) scale(1)",
      "&.MuiInputLabel-shrink": {
        transform: "translate(14px, -6px) scale(0.75)",
      },
    },
  },
    tagChip: {
    margin: "1px 3px !important",
    fontSize: "0.75rem !important",
    height: "24px !important",
    maxHeight: "24px !important",
    fontWeight: "600 !important",
    borderRadius: "12px !important",
    color: "#FFFFFF !important",
    fontFamily: `${theme.typography.fontFamily} !important`,
    backgroundColor: theme.palette.type === "dark" ? "#1E293B !important" : "#334155 !important",
    border: "1px solid rgba(255, 255, 255, 0.2) !important",
    boxSizing: "border-box !important",
    "& .MuiChip-label": {
      padding: "0 8px !important",
      fontSize: "0.75rem !important",
      fontWeight: "600 !important",
    },
    "& .MuiChip-deleteIcon": {
      width: "16px !important",
      height: "16px !important",
      color: "rgba(255, 255, 255, 0.7) !important",
      marginRight: "4px !important",
      "&:hover": {
        color: "#FFFFFF !important",
      },
    },
  }
}));

export function UsersFilter({ onFiltered, initialUsers, style }) {
  const classes = useStyles();
  const [users, setUsers] = useState([]);
  const [selecteds, setSelecteds] = useState([]);

  useEffect(() => {
    async function fetchData() {
      await loadUsers();
    }
    fetchData();
  }, []);

  useEffect(() => {
    setSelecteds([]);
    if (
      Array.isArray(initialUsers) &&
      Array.isArray(users) &&
      users.length > 0
    ) {
      onChange(initialUsers);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialUsers, users]);

  const loadUsers = async () => {
    try {
      const { data } = await api.get(`/users/list`);
      const userList = data.map((u) => ({ id: u.id, name: u.name }));
      setUsers(userList);
    } catch (err) {
      toastError(err);
    }
  };

  const onChange = async (value) => {
    setSelecteds(value);
    onFiltered(value);
  };

  return (
    <Box style={style !== undefined ? style : { padding: "0px 10px 10px" }}>
      <Autocomplete
        multiple
        size="small"
        options={users}
        value={selecteds}
        onChange={(e, v, r) => onChange(v)}
        getOptionLabel={(option) => option.name}
        getOptionSelected={(option, value) => {
          return (
            option?.id === value?.id ||
            option?.name.toLowerCase() === value?.name.toLowerCase()
          );
        }}
        renderTags={(value, getUserProps) =>
          value.map((option, index) => (
            <Chip
              variant="outlined"
              className={classes.tagChip}
              
              label={option.name}
              {...getUserProps({ index })}
              size="small"
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label={i18n.t("tickets.advancedFilters.filterUser")}
            InputLabelProps={{ shrink: true }}
            placeholder={selecteds.length === 0 ? i18n.t("tickets.advancedFilters.filterUserAll") : ""}
            className={classes.autocompleteInput}
          />
        )}
      />
    </Box>
  );
}
